module.exports = __webpack_public_path__ + "img/mm.c379fe00.svg";